import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { getTenantId } from "../helper";
import { plainToClass } from "class-transformer";
import { IPageDTO, IPageElementDTO, PageElementModel, PageManagerModel, } from "../models/pageManager/PageManager";
let PageManagersModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    let PageManagersModule = class PageManagersModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.pages = [];
            this.page = new PageManagerModel();
            this.pageElements = [];
            // pageElement: IPageElementDTO = { id: null, text: "", description: "", pageId: null, isRoot:null, displayOrder: '', state: null };
            this.pageElement = new PageElementModel();
            this.features = [];
        }
        async GetPageManager() {
            var url = `${getTenantId()}/PageManager`;
            let { data } = await service.get(url);
            if (data) {
                this.SetPages(data.pages);
                this.SetFeatures(data.features);
            }
            return [];
        }
        SetPages(pages) {
            this.pages = pages;
        }
        SetFeatures(features) {
            this.features = features;
        }
        async AddPage(newpage) {
            var url = `${getTenantId()}/PageManager`;
            let { data } = await service.post(url, newpage);
            if (data) {
                this.SetAddPage(data.page);
                return data;
            }
        }
        SetAddPage(page) {
            this.pages.push(page);
        }
        async UpdatePage(updatePage) {
            var url = `${getTenantId()}/PageManager`;
            let { data } = await service.put(url, updatePage);
            if (data) {
                this.SetUpdatePage(data.page);
                return data;
            }
        }
        SetUpdatePage(page) {
            var that = this;
            var target = that.pages.findIndex((x) => x.id == page.id);
            if (target !== -1) {
                that.pages[target] = plainToClass(PageManagerModel, page);
            }
            else {
                that.pages.push(plainToClass(PageManagerModel, page));
            }
            that.pages = [...that.pages];
        }
        async DeletePage(pageId) {
            var url = `${getTenantId()}/PageManager/` + pageId + `/delete`;
            let { data } = await service.post(url);
            if (data) {
                this.SetDeletePage(data.pageId);
                return data;
            }
        }
        SetDeletePage(pageId) {
            const index = this.pages
                .map(function (array) {
                return array.id;
            })
                .indexOf(pageId, 0);
            if (index > -1) {
                this.pages.splice(index, 1);
            }
        }
        async GetPageElements(pageId) {
            var url = `${getTenantId()}/PageManager/` + pageId + `/pageElement`;
            let { data } = await service.get(url);
            if (data) {
                this.SetPageElements(data.pageElements);
            }
            return [];
        }
        SetPageElements(pageElements) {
            this.pageElements = pageElements;
        }
        async AddPageElements(pageElement) {
            var url = `${getTenantId()}/PageManager/` + pageElement.pageId + `/pageElement`;
            let { data } = await service.post(url, pageElement);
            if (data) {
                this.SetAddPageElement(data.pageElement);
                return data;
            }
        }
        SetAddPageElement(pageElement) {
            this.pageElements.push(pageElement);
        }
        async UpdatePageElement(pageElement) {
            var url = `${getTenantId()}/PageManager/` + pageElement.pageId + `/pageElement`;
            let { data } = await service.put(url, pageElement);
            if (data) {
                this.SetPageElement(data.pageElement);
                return data;
            }
        }
        SetPageElement(pageElement) {
            var that = this;
            var target = that.pageElements.findIndex((x) => x.id == pageElement.id);
            if (target !== -1) {
                that.pageElements[target] = plainToClass(PageElementModel, pageElement);
            }
            else {
                that.pageElements.push(plainToClass(PageElementModel, pageElement));
            }
            that.pageElements = [...that.pageElements];
        }
        async DeletePageElementById(requestId) {
            var url = `${getTenantId()}/PageManager/pageElement/${requestId}/delete`;
            let { data } = await service.post(url);
            if (data) {
                this.SetDeleteDetail(data.pageElementId);
                return data;
            }
        }
        SetDeleteDetail(pageElementId) {
            const index = this.pageElements
                .map(function (array) {
                return array.id;
            })
                .indexOf(pageElementId, 0);
            var pageDetail = this.pageElements.filter((pageElement) => pageElement.id == pageElementId)[0];
            if (index > -1) {
                this.pageElements.splice(index, 1);
            }
            var page = this.pages.filter((page) => page.id == pageDetail.pageId)[0];
            // page.name = this.pageElements.filter(
            //     (pageElements: any) => pageElements.pageId == page.id
            // ).length;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], PageManagersModule.prototype, "GetPageManager", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PageManagersModule.prototype, "SetPages", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PageManagersModule.prototype, "SetFeatures", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof PageManagerModel !== "undefined" && PageManagerModel) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], PageManagersModule.prototype, "AddPage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof IPageDTO !== "undefined" && IPageDTO) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], PageManagersModule.prototype, "SetAddPage", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof PageManagerModel !== "undefined" && PageManagerModel) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], PageManagersModule.prototype, "UpdatePage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof IPageDTO !== "undefined" && IPageDTO) === "function" ? _g : Object]),
        __metadata("design:returntype", void 0)
    ], PageManagersModule.prototype, "SetUpdatePage", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], PageManagersModule.prototype, "DeletePage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], PageManagersModule.prototype, "SetDeletePage", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], PageManagersModule.prototype, "GetPageElements", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PageManagersModule.prototype, "SetPageElements", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof PageElementModel !== "undefined" && PageElementModel) === "function" ? _k : Object]),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], PageManagersModule.prototype, "AddPageElements", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof IPageElementDTO !== "undefined" && IPageElementDTO) === "function" ? _m : Object]),
        __metadata("design:returntype", void 0)
    ], PageManagersModule.prototype, "SetAddPageElement", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof IPageElementDTO !== "undefined" && IPageElementDTO) === "function" ? _o : Object]),
        __metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
    ], PageManagersModule.prototype, "UpdatePageElement", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_q = typeof IPageElementDTO !== "undefined" && IPageElementDTO) === "function" ? _q : Object]),
        __metadata("design:returntype", void 0)
    ], PageManagersModule.prototype, "SetPageElement", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_r = typeof Promise !== "undefined" && Promise) === "function" ? _r : Object)
    ], PageManagersModule.prototype, "DeletePageElementById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], PageManagersModule.prototype, "SetDeleteDetail", null);
    PageManagersModule = __decorate([
        Module({ dynamic: true, store: store, name: "PageManager", namespaced: true })
    ], PageManagersModule);
    return PageManagersModule;
})();
export const PageManagerModule = getModule(PageManagersModule);
